<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px" class="el-form-title">
      <el-form-item label="故事名称">
        <el-input v-model="form.name" placeholder="请输入需要查询的故事名称" />
        <el-button @click="fetchData">查询</el-button>
        <el-button type="primary" @click="showAddDialog">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="calc(100vh - 200px)"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
      :empty-text="'暂无数据'"
    >
      <el-table-column align="center" label="故事名称" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
       <el-table-column align="center" label="描述" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.description || '暂无' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

     
      <el-table-column align="center" label="操作" min-width="500" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button @click="editQuestionPrompt(scope.row)">出题提示词</el-button>
          <el-button @click="editTipPrompt(scope.row)">提示提示词</el-button>
          <el-button @click="editScoreRule(scope.row)">评分规则</el-button> -->
          <el-button @click="editItem(scope.row)">编辑</el-button>
          <el-button @click="goToQA(scope.row.id)">问题</el-button>
          <el-button @click="delItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增故事弹窗 -->
    <el-dialog title="新增故事" :visible.sync="addDialogVisible" width="600px" top="15%">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="故事名称" required>
          <el-input v-model="addForm.name" placeholder="请输入故事名称" />
        </el-form-item>
        <el-form-item label="故事描述">
          <el-input v-model="addForm.description" type="textarea" placeholder="请输入故事描述" :rows="3" />
        </el-form-item>
        <el-form-item label="选择模板">
          <el-select v-model="addForm.templateId" filterable placeholder="请选择模板（可选）" value-key="id">
            <el-option v-for="template in templateList" :key="template.id" :label="template.name" :value="template.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdd">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑出题提示词弹窗 -->
    <el-dialog title="编辑出题提示词" :visible.sync="questionPromptDialogVisible" width="800px" height="800px" top="2%">
      <el-form ref="questionPromptForm" :model="questionPromptForm" label-width="120px">
        <el-form-item label="出题提示词">
          <el-input v-model="questionPromptForm.questionPrompt" type="textarea" placeholder="请输入出题提示词" :rows="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionPromptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuestionPrompt">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑提示提示词弹窗 -->
    <el-dialog title="编辑提示提示词" :visible.sync="tipPromptDialogVisible" width="800px" height="800px" top="2%">
      <el-form ref="tipPromptForm" :model="tipPromptForm" label-width="120px">
        <el-form-item label="提示提示词">
          <el-input v-model="tipPromptForm.tipPrompt" type="textarea" placeholder="请输入提示提示词" :rows="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipPromptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTipPrompt">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑评分规则弹窗 -->
    <el-dialog title="编辑评分规则" :visible.sync="scoreRuleDialogVisible" width="800px" height="600px" top="8%">
      <el-form ref="scoreRuleForm" :model="scoreRuleForm" label-width="120px">
        <el-form-item label="评分规则">
          <el-input v-model="scoreRuleForm.scoreRule" type="textarea" placeholder="请输入评分规则" :rows="15" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scoreRuleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmScoreRule">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { storyList, delStory, storyAdd, storyUpdate, templateAllList } from '@/api/exercise'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      list: [],
      listLoading: false,
      addDialogVisible: false,
      questionPromptDialogVisible: false,
      tipPromptDialogVisible: false,
      scoreRuleDialogVisible: false,
      form: {
        name: ''
      },
      addForm: {
        name: '',
        description: '',
        templateId: ''
      },
      templateList: [],
      questionPromptForm: {
        id: '',
        questionPrompt: ''
      },
      tipPromptForm: {
        id: '',
        tipPrompt: ''
      },
      scoreRuleForm: {
        id: '',
        scoreRule: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.listLoading = true
      const params = {
        page: 1,
        pageSize: 10,
        name: this.form.name
      }
      storyList(params).then(response => {
        const records = response.data.records || []
        records.forEach(res => {
          res.createTime = dayjs(res.createTime).format('YYYY-MM-DD HH:mm:ss')
          res.updateTime = dayjs(res.updateTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.list = records
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    showAddDialog() {
      this.addForm = {
        id: null,
        name: '',
        description: '',
        templateId: ''
      }
      // 获取模板列表
      templateAllList().then(res => {
        this.templateList = res.data || []
      })
      this.addDialogVisible = true
    },
    editItem(row) {
      this.addForm = {
        id: row.id,
        name: row.name || '',
        description: row.description || '',
        templateId: row.templateId || ''
      }
      // 获取模板列表
      templateAllList().then(res => {
        this.templateList = res.data || []
      })
      this.addDialogVisible = true
    },
    confirmAdd() {
      if (!this.addForm.name) {
        this.$message({
          message: '请输入故事名称',
          type: 'error',
          duration: 2 * 1000
        })
        return
      }
      // 构建参数，只有选择了模板才传 templateId
      const params = {
        name: this.addForm.name,
        description: this.addForm.description
      }
      if (this.addForm.templateId) {
        params.templateId = this.addForm.templateId
      }
      // 判断是新增还是编辑
      const api = this.addForm.id ? storyUpdate : storyAdd
      if (this.addForm.id) {
        params.id = this.addForm.id
      }
      api(params).then(() => {
        this.$message({
          type: 'success',
          message: this.addForm.id ? '编辑成功' : '新增成功',
          duration: 2 * 1000
        })
        this.addDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: this.addForm.id ? '编辑失败' : '新增失败',
          duration: 2 * 1000
        })
      })
    },
    goToQA(storyId) {
      this.$router.push({ name: 'storyQA', query: { storyId } })
    },
    delItem(id) {
      this.$confirm('此操作将删除该故事, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delStory({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败',
            duration: 2 * 1000
          })
        })
      })
    },
    editQuestionPrompt(row) {
      this.questionPromptForm = {
        id: row.id,
        questionPrompt: row.questionPrompt || ''
      }
      this.questionPromptDialogVisible = true
    },
    confirmQuestionPrompt() {
      storyUpdate({
        id: this.questionPromptForm.id,
        questionPrompt: this.questionPromptForm.questionPrompt
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.questionPromptDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    },
    editTipPrompt(row) {
      this.tipPromptForm = {
        id: row.id,
        tipPrompt: row.tipPrompt || ''
      }
      this.tipPromptDialogVisible = true
    },
    confirmTipPrompt() {
      storyUpdate({
        id: this.tipPromptForm.id,
        tipPrompt: this.tipPromptForm.tipPrompt
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.tipPromptDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    },
    editScoreRule(row) {
      this.scoreRuleForm = {
        id: row.id,
        scoreRule: row.scoreRule || ''
      }
      this.scoreRuleDialogVisible = true
    },
    confirmScoreRule() {
      storyUpdate({
        id: this.scoreRuleForm.id,
        scoreRule: this.scoreRuleForm.scoreRule
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.scoreRuleDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-table{
    overflow: auto;
  }
  .el-form-item__content{
    display: flex;
    position: relative;
  }
  .el-button {
    margin-left: 10px;
  }
  .el-button:last-child{
    color: #FFF;
    background-color: #409EFF;
  }
  .el-input__inner {
    width: 400px;
  }
}
 /* .align-right {
 position: absolute;
  right: 0;
 } */
.el-form-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>

